/**
 * MissionCompletionView — écran de fin d'une activité menée avec Sam.
 *
 * Ne réinvente rien : c'est l'écran de fin CANONIQUE du flux standard
 * (`ActivityFinalizedCongrats`) avec la mascotte Sam et les sorties propres à
 * la session. La version précédente le redessinait, et en héritait trois
 * écarts d'un coup — « petals » en anglais, l'ancienne palette verte
 * (`petalDarker`) au lieu de `petalNew`, et un seul compteur là où l'écran
 * canonique en montre trois (XP, Pétales, Chrono) avec un champion à 85 % de
 * la largeur. Réutiliser les règle tous, et les garde réglés.
 *
 * Il vient après la correction, comme l'écran de fin standard : la charge du
 * congrats remonte du wrapper d'activité par `onCompletionScreen`.
 */
import React from "react"
import ActivityFinalizedCongrats from "../../activity/execute/ActivityFinalizedCongrats"

const MissionCompletionView = ({
    // Charge complète du congrats standard, telle que construite par
    // `ActivityScreen.pushSuccessScreen` : { activity, userSkillSets,
    // petalsGained, chapterProgress, newTitleSkillSet? }. L'activité porte
    // `xp_gained` et `duration`, donc les compteurs XP et Chrono.
    congratsData = null,
    // Id de l'activité suivante à enchaîner avec Sam, quelle qu'en soit
    // l'origine — prescription du tuteur, programme de révisions ou todo
    // libre. Le calcul appartient au parent (SamSessionScreen).
    nextActivityId = null,
    onNextActivity,
    onBackToTodo,
}) => {
    const hasNext = !!nextActivityId && typeof onNextActivity === "function"

    const secondaryActions = hasNext
        ? [
              {
                  key: "back-to-todo",
                  label: "Retour à ma todo",
                  icon: "home",
                  onPress: onBackToTodo,
              },
          ]
        : []

    return (
        <ActivityFinalizedCongrats
            congratsData={congratsData || {}}
            activity={congratsData?.activity}
            championName="sam"
            continueLabel={
                hasNext ? "ACTIVITÉ SUIVANTE AVEC SAM" : "RETOUR À MA TODO"
            }
            secondaryActions={secondaryActions}
            onContinuePress={
                hasNext ? () => onNextActivity(nextActivityId) : onBackToTodo
            }
        />
    )
}

export default MissionCompletionView
